module.exports = __webpack_public_path__ + "img/corner-badge.d995da87.svg";